import { AfterContentInit, Component, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { normalizeOptionLabel } from '@app/shared/util/common-utils';
import { DynamicFormService } from '@ntap/common';
import {
  AttributeStateService,
  ItemInfo,
  ItemViewProviderDirective,
  NtapCommonComponent
} from '@ntap/core';
import { delay, map, of, startWith, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-datoteka',
  templateUrl: './datoteka.component.html',
  styleUrls: ['./datoteka.component.scss']
})
export class DatotekaComponent
  extends NtapCommonComponent
  implements AfterContentInit
{
  private formService = inject(DynamicFormService);
  private attributeStateService = inject(AttributeStateService);
  private itemViewProvider = inject(ItemViewProviderDirective);

  isDirectory$ = this.itemViewProvider.item$.pipe(
    map((item: any) => {
      return item['en~datoteka~is_directory'] || false;
    })
  );
  obrazacClass: string;

  ngAfterContentInit(): void {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          delay(0),
          switchMap((item: any) => {
            return this.formService.formGroup$.pipe(
              switchMap((fg) => {
                const vrstaControl =
                  fg.get('en~datoteka~vrsta_objekta_id') ||
                  ({ valueChanges: of(null) } as AbstractControl);

                return vrstaControl.valueChanges.pipe(
                  startWith(
                    this.formService.getFormValue(
                      'en~datoteka~vrsta_objekta_id'
                    )
                  ),
                  switchMap((value) => {
                    return this.fetchOptions(item).pipe(
                      tap((options) => {
                        const option = options.filter(
                          (o) => o.value === value
                        )[0] || { label: '' };
                        const normalizedLabel = normalizeOptionLabel(option);
                        this.obrazacClass = `vrsta-${normalizedLabel}`;
                      })
                    );
                  })
                );
              })
            );
          })
        )
        .subscribe()
    );
  }

  private fetchOptions(item: any) {
    return this.attributeStateService.getAllowedValues(
      {
        $fqan: 'en~datoteka~vrsta_objekta_id',
        name: 'en~datoteka~vrsta_objekta_id'
      },
      {
        ['en~datoteka~id']: new ItemInfo(item).id
      },
      'datoteka_item'
    );
  }
}
